module.exports = __webpack_public_path__ + "img/bg.4714d9d2.webp";